(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const headerAlways = document.querySelector(".header-always");

		if (headerAlways) {
			header.classList.add("always-show");
		}

		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		//menuLinks &&
		//	menuLinks.forEach((link) => {
		//		link.addEventListener("mouseenter", (e) => {
		//			if (link.classList.contains("list-menu--megamenu")) {
		//				link.classList.add("list-menu--megamenu-visible");
		//				if (
		//					header.classList.contains("color-background-2") &&
		//					!header.classList.contains("shopify-section-header-sticky")
		//				) {
		//					header.classList.remove("color-background-2");
		//				}

		//				menuLinks.forEach((el) => {
		//					if (el !== link) {
		//						el.classList.remove("list-menu--megamenu-visible");
		//					}
		//				});
		//			} else {
		//				menuLinks.forEach((el) => {
		//					el.classList.remove("list-menu--megamenu-visible");
		//				});
		//			}
		//		});
		//	});
		//menu &&
		//	menu.addEventListener("mouseleave", (e) => {
		//		menuLinks.forEach((link) => {
		//			link.classList.remove("list-menu--megamenu-visible");
		//		});
		//	});

		const addBackground = () => {
			if (document.querySelector(".overflow-hidden-drawer")) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1100) {
					if (
						header.classList.contains("color-background-2") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-2");
					}

					if (
						header.classList.contains("section--has-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("have-background");
					}
				}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {
			if (
				document.querySelector(".overflow-hidden") ||
				document.querySelector(".overflow-hidden-drawer")
			) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1100) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("color-background-2");
					}

					if (
						header.classList.contains("section--has-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("have-background");
					}
				}
			});

			headerObserver.observe(header);
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		document.addEventListener("DOMContentLoaded", () => {
			const firstSection = document.querySelector(
				"main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
			);
			let isSectionVisible = false;
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting && !isSectionVisible) {
						isSectionVisible = true;
						header.classList.add("entering-section", "color-background-2");
					} else if (!entry.isIntersecting && isSectionVisible) {
						isSectionVisible = false;
						header.classList.remove("entering-section");
					}
				},
				{ threshold: 0.15 }
			);

			if (firstSection) {
				observer.observe(firstSection);
			}

			window.addEventListener("scroll", () => {
				if (isSectionVisible) {
					header.classList.add("entering-section", "color-background-2");
				}
			});
		});

		//const megaMenuListLinks = () => {
		//	const megaMenuLinkWithSubmenu = document.querySelector(
		//		".mega-menu__list-item--children"
		//	);
		//	const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
		//	if (megaMenuLinkWithSubmenu) {
		//		megaMenuLinks.forEach((link) => {
		//			link.classList.add("mega-menu__list-item--opacity");
		//		});
		//		megaMenuLinkWithSubmenu.classList.remove(
		//			"mega-menu__list-item--opacity"
		//		);
		//		megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
		//	}
		//	$(".mega-menu__list-item").mouseenter(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//	$(".mega-menu__list-item").focus(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//};

		//const megaMenuSublinks = () => {
		//	$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
		//		event
		//	) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//	$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).focusout(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//};
		//megaMenuListLinks();
		//megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelectorAll(".shopify-section")[0]
				?.classList.contains("section--has-overlay") &&
			!main
				.querySelectorAll(".shopify-section")[0]
				?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-2");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-2");
			}
		}
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();



class MobileDrawerSlideMenu {
  constructor(drawer) {
    this.drawer = drawer;
    this.mediaQuery = window.matchMedia("(max-width: 1099px)");

    this.handleClick = this.handleClick.bind(this);
    this.handleMediaChange = this.handleMediaChange.bind(this);

    this.init();
  }

  init() {
    this.drawer.addEventListener("click", this.handleClick);
    this.mediaQuery.addEventListener("change", this.handleMediaChange);
  }

  handleClick(event) {
    if (!this.mediaQuery.matches) return;

    const summary = event.target.closest("summary");
    const closeButton = event.target.closest(
      ".menu-drawer__close-button"
    );

    /*
     * 親項目をクリックしたとき
     */
    if (summary && this.drawer.contains(summary)) {
      const details = summary.closest("details");
      const submenu = details?.querySelector(
        ":scope > .menu-drawer__submenu"
      );

      if (!details || !submenu) return;

      event.preventDefault();

      this.openSubmenu(details, summary, submenu);
      return;
    }

    /*
     * 戻るボタンをクリックしたとき
     */
    if (closeButton && this.drawer.contains(closeButton)) {
      const submenu = closeButton.closest(".menu-drawer__submenu");
      const details = submenu?.parentElement;

      if (!details?.matches("details")) return;

      event.preventDefault();

      this.closeSubmenu(details);
    }
  }

  openSubmenu(details, summary, submenu) {
    /*
     * CSSのdetails[open]依存を避けつつ、
     * アクセシビリティ用にopenも設定
     */
    details.open = true;
    details.classList.add("is-submenu-open");

    summary.setAttribute("aria-expanded", "true");
    submenu.setAttribute("aria-hidden", "false");

    /*
     * スライド後に戻るボタンへフォーカス
     */
    window.setTimeout(() => {
      const closeButton = submenu.querySelector(
        ":scope > .menu-drawer__inner-submenu > .menu-drawer__close-button"
      );

      closeButton?.focus();
    }, 350);
  }

  closeSubmenu(details) {
    const summary = details.querySelector(":scope > summary");
    const submenu = details.querySelector(
      ":scope > .menu-drawer__submenu"
    );

    details.classList.remove("is-submenu-open");

    summary?.setAttribute("aria-expanded", "false");
    submenu?.setAttribute("aria-hidden", "true");

    window.setTimeout(() => {
      details.open = false;
      summary?.focus();
    }, 350);
  }

  handleMediaChange(event) {
    /*
     * PCに戻ったときは、SP用の状態をリセット
     */
    if (!event.matches) {
      this.reset();
    }
  }

  reset() {
    this.drawer
      .querySelectorAll("details.is-submenu-open")
      .forEach((details) => {
        details.classList.remove("is-submenu-open");
        details.open = false;

        details
          .querySelector(":scope > summary")
          ?.setAttribute("aria-expanded", "false");

        details
          .querySelector(":scope > .menu-drawer__submenu")
          ?.setAttribute("aria-hidden", "true");
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".menu-drawer")
    .forEach((drawer) => {
      if (drawer.dataset.slideMenuInitialized === "true") return;

      drawer.dataset.slideMenuInitialized = "true";
      new MobileDrawerSlideMenu(drawer);
    });
});

// ========================================
// HEADER SUBMENU IMAGES
// ========================================

class HeaderSubmenuSlider {

  constructor(element) {

    this.element = element;

    this.viewport =
      element.querySelector(
        '.header-submenu-slider__viewport'
      );

    this.track =
      element.querySelector(
        '.header-submenu-slider__track'
      );

    this.slides = [
      ...element.querySelectorAll(
        '.header-submenu-slider__slide'
      )
    ];

    this.prev =
      element.querySelector(
        '[data-header-slider-prev]'
      );

    this.next =
      element.querySelector(
        '[data-header-slider-next]'
      );


    /*
     * 必須要素がなければ終了
     */
    if (
      !this.viewport ||
      !this.track
    ) {
      return;
    }


    /*
     * 4枚未満の場合は
     * スライダー機能を付けない
     */
    if (
      !this.element.classList.contains('is-slider') ||
      this.slides.length < 4
    ) {
      return;
    }


    this.bindEvents();


    /*
     * 画像読み込み後に
     * サイズを再計算
     */
    this.waitForImages();


    /*
     * 初期状態
     */
    requestAnimationFrame(() => {

      this.updateControls();

    });

  }



  // ========================================
  // 画像読み込み待ち
  // ========================================

  waitForImages() {

    const images =
      this.element.querySelectorAll('img');


    if (!images.length) {

      this.updateControls();

      return;

    }


    let loadedCount = 0;


    const done = () => {

      loadedCount += 1;


      if (loadedCount < images.length) {
        return;
      }


      requestAnimationFrame(() => {

        this.updateControls();

      });

    };


    images.forEach((image) => {

      if (image.complete) {

        done();

      } else {

        image.addEventListener(
          'load',
          done,
          {
            once: true
          }
        );


        image.addEventListener(
          'error',
          done,
          {
            once: true
          }
        );

      }

    });

  }



  // ========================================
  // 現在のスクロール位置
  // ========================================

  getCurrentScrollLeft() {

    return this.viewport.scrollLeft;

  }



  // ========================================
  // 最大スクロール位置
  // ========================================

  getMaxScrollLeft() {

    return Math.max(
      0,
      this.viewport.scrollWidth -
      this.viewport.clientWidth
    );

  }



  // ========================================
  // 各スライドの開始位置を取得
  // ========================================

  getSlidePositions() {

    const viewportRect =
      this.viewport.getBoundingClientRect();


    const currentScroll =
      this.viewport.scrollLeft;


    return this.slides.map((slide) => {

      const slideRect =
        slide.getBoundingClientRect();


      return (
        slideRect.left -
        viewportRect.left +
        currentScroll
      );

    });

  }



  // ========================================
  // NEXT
  // ========================================

  scrollNext() {

    const current =
      this.getCurrentScrollLeft();


    const max =
      this.getMaxScrollLeft();


    const positions =
      this.getSlidePositions();


    /*
     * 現在位置より右側にある
     * 最初のスライドを探す
     */
    const nextPosition =
      positions.find((position) => {

        return position > current + 2;

      });


    /*
     * 次が存在しなければ
     * 最後まで移動
     */
    const target =
      nextPosition !== undefined
        ? Math.min(nextPosition, max)
        : max;


    this.viewport.scrollTo({

      left: target,

      behavior: 'smooth'

    });

  }



  // ========================================
  // PREV
  // ========================================

  scrollPrev() {

    const current =
      this.getCurrentScrollLeft();


    const positions =
      this.getSlidePositions();


    /*
     * 現在位置より左側にある
     * スライドだけ取得
     */
    const previousPositions =
      positions.filter((position) => {

        return position < current - 2;

      });


    /*
     * 一番近い左側のスライド
     */
    const target =
      previousPositions.length
        ? previousPositions[
            previousPositions.length - 1
          ]
        : 0;


    this.viewport.scrollTo({

      left: target,

      behavior: 'smooth'

    });

  }



  // ========================================
  // 矢印状態
  // ========================================

  updateControls() {

    const current =
      this.getCurrentScrollLeft();


    const max =
      this.getMaxScrollLeft();


    /*
     * ブラウザの小数誤差対策
     */
    const tolerance = 2;


    if (this.prev) {

      this.prev.disabled =
        current <= tolerance;

    }


    if (this.next) {

      this.next.disabled =
        current >= max - tolerance;

    }

  }



  // ========================================
  // 表示された時の再計算
  // ========================================

  refresh() {

    /*
     * display:none → block の直後は
     * サイズ取得が安定しない場合があるため
     * requestAnimationFrameを2回通す
     */

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        this.updateControls();

      });

    });

  }



  // ========================================
  // Events
  // ========================================

  bindEvents() {


    /*
     * PREV
     */
    this.prev?.addEventListener(
      'click',
      (event) => {

        event.preventDefault();

        event.stopPropagation();

        this.scrollPrev();

      }
    );


    /*
     * NEXT
     */
    this.next?.addEventListener(
      'click',
      (event) => {

        event.preventDefault();

        event.stopPropagation();

        this.scrollNext();

      }
    );


    /*
     * スワイプ / トラックパッドなどで
     * viewportが動いた時
     */
    this.viewport.addEventListener(
      'scroll',
      () => {

        this.updateControls();

      },
      {
        passive: true
      }
    );


    /*
     * リサイズ
     */
    window.addEventListener(
      'resize',
      () => {

        this.updateControls();

      },
      {
        passive: true
      }
    );

  }

}



// ========================================
// HEADER SLIDER INIT
// ========================================

function initHeaderSubmenuSliders(root = document) {

  root
    .querySelectorAll(
      '[data-header-submenu-slider]'
    )
    .forEach((element) => {


      /*
       * 初期化済み
       */
      if (
        element.dataset.sliderInitialized === 'true'
      ) {
        return;
      }


      element.dataset.sliderInitialized =
        'true';


      const slider =
        new HeaderSubmenuSlider(element);


      /*
       * 後からrefreshできるように保存
       */
      element.headerSubmenuSlider =
        slider;

    });

}



// ========================================
// HEADER IMAGE SWITCH
// ========================================

function initHeaderSubmenuImages(root = document) {

  root
    .querySelectorAll('.header__submenu')
    .forEach((submenu) => {


      /*
       * 初期化済み
       */
      if (
        submenu.dataset.headerImagesInitialized === 'true'
      ) {
        return;
      }


      submenu.dataset.headerImagesInitialized =
        'true';


      const links =
        submenu.querySelectorAll(
          '[data-menu-image-key]'
        );


      const sliders =
        submenu.querySelectorAll(
          '[data-menu-image-group]'
        );


      const parentItem =
        submenu.closest(
          '.list-menu-item'
        );


      const parentLink =
        parentItem?.querySelector(
          ':scope > a, :scope > details > summary'
        );


      const parentTitle =
        parentLink
          ?.textContent
          ?.trim()
          ?.toLowerCase();



      // ========================================
      // 全画像を非表示
      // ========================================

      const hideAll = () => {

        sliders.forEach((slider) => {

          slider.classList.remove(
            'is-active'
          );

        });

      };



      // ========================================
      // Slider refresh
      // ========================================

      const refreshSlider = (slider) => {

        if (!slider) {
          return;
        }


        slider
          .headerSubmenuSlider
          ?.refresh();

      };



      // ========================================
      // Slider表示
      // ========================================

      const showSlider = (slider) => {

        if (!slider) {
          return false;
        }


        hideAll();


        slider.classList.add(
          'is-active'
        );


        refreshSlider(slider);


        return true;

      };



      // ========================================
      // 親画像
      // ========================================

      const showDefault = () => {


        const parentSlider =
          submenu.querySelector(
            '[data-menu-image-group="parent"]'
          );


        if (parentSlider) {

          showSlider(parentSlider);

        } else {

          hideAll();

        }

      };



      // ========================================
      // 子メニュー hover
      // ========================================

      links.forEach((link) => {

        link.addEventListener(
          'mouseenter',
          () => {


            const key =
              link.dataset.menuImageKey;


            if (!key) {

              showDefault();

              return;

            }


            const target =
              submenu.querySelector(
                `[data-menu-image-group="${CSS.escape(key)}"]`
              );


            /*
             * 子画像が存在する場合
             */
            if (target) {

              showSlider(target);

              return;

            }


            /*
             * 子画像がない場合
             * 親画像へ戻す
             */
            showDefault();

          }
        );

      });



      // ========================================
      // submenuから出た時
      // ========================================

      submenu.addEventListener(
        'mouseleave',
        () => {

          showDefault();

        }
      );



      // ========================================
      // 初期状態
      // ========================================

      showDefault();

    });

}



// ========================================
// SP DRAWER IMAGES
// ========================================

function initDrawerMenuImages(root = document) {

  root
    .querySelectorAll(
      '[data-drawer-menu-images]'
    )
    .forEach((imageArea) => {


      /*
       * 初期化済み
       */
      if (
        imageArea.dataset.drawerImagesInitialized === 'true'
      ) {
        return;
      }


      imageArea.dataset.drawerImagesInitialized =
        'true';


      const submenu =
        imageArea.closest(
          '.menu-drawer__submenu'
        );


      if (!submenu) {
        return;
      }


      const links =
        submenu.querySelectorAll(
          '[data-menu-image-key]'
        );


      const sliders =
        imageArea.querySelectorAll(
          '[data-menu-image-group]'
        );


      const parentMenu =
        imageArea.dataset.parentMenu;



      // ========================================
      // 全非表示
      // ========================================

      const hideAll = () => {

        sliders.forEach((slider) => {

          slider.classList.remove(
            'is-active'
          );

        });

      };



      // ========================================
      // 親画像
      // ========================================

      const showDefault = () => {

        hideAll();


        const parentSlider =
          imageArea.querySelector(
            '[data-menu-image-group="parent"]'
          );


        if (parentSlider) {

          parentSlider.classList.add(
            'is-active'
          );

        }

      };



      // ========================================
      // 指定画像表示
      // ========================================

      const showImage = (key) => {

        if (!key) {

          showDefault();

          return;

        }


        const target =
          imageArea.querySelector(
            `[data-menu-image-group="${CSS.escape(key)}"]`
          );


        if (!target) {

          showDefault();

          return;

        }


        hideAll();


        target.classList.add(
          'is-active'
        );

      };



      // ========================================
      // Menu click
      // ========================================

      links.forEach((link) => {

        link.addEventListener(
          'click',
          () => {

            const key =
              link.dataset.menuImageKey;


            if (!key) {
              return;
            }


            showImage(key);

          }
        );

      });



      // ========================================
      // 戻るボタン
      // ========================================

      submenu
        .querySelector(
          ':scope > .menu-drawer__inner-submenu > .menu-drawer__close-button'
        )
        ?.addEventListener(
          'click',
          () => {

            showDefault();

          }
        );



      // ========================================
      // 初期状態
      // ========================================

      showDefault();

    });

}



// ========================================
// INIT ALL
// ========================================

function initHeaderImages(root = document) {

  /*
   * 先にSliderを初期化
   */
  initHeaderSubmenuSliders(root);


  /*
   * PC画像切替
   */
  initHeaderSubmenuImages(root);


  /*
   * SP画像切替
   */
  initDrawerMenuImages(root);

}



// ========================================
// DOMContentLoaded
// ========================================

document.addEventListener(
  'DOMContentLoaded',
  () => {

    initHeaderImages();

  }
);



// ========================================
// Shopify Theme Editor
// ========================================

document.addEventListener(
  'shopify:section:load',
  (event) => {

    initHeaderImages(
      event.target
    );

  }
);